import { useLayoutEffect } from "react";

import useCurrentEnvironment from "./use-environment";
import usePrevious from "./use-previous";

// This is a hook used for running a function when the environment is initially loaded on the page
// It doesn't run when the environment is updated later on by the user.
function useOnEnvironmentLoads(callback: Function) {
  const currentEnvironment = useCurrentEnvironment();
  const previousCurrentEnvironment = usePrevious(currentEnvironment);

  // Using layout effect in case the callback function needs to update refs.
  // If callback is async, this ends up just being the same as useEffect, but if callback is sync, the component won't
  // re-render until the callback is complete.
  useLayoutEffect(() => {
    if (!previousCurrentEnvironment && !!currentEnvironment) {
      // When the environment first changes
      callback(currentEnvironment);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEnvironment, callback]);
}

export default useOnEnvironmentLoads;
